// A tiny event-driven service for lead updates across all pages

const EVENT_NAME = "leadUpdated";

export function emitLeadUpdate(lead) {
  // lead can be a full object or just { id, status }
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: lead }));
}

export function subscribeLeadUpdates(callback) {
  const handler = (e) => callback(e.detail);
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
